import "./GetAQuote.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import BookingInquirySection from "./sections/BookingInquirySection";
export default function GetAQuotePage() {
  return <div>
      <Header />
      <div className="container mx-auto px-4 py-16">
        
      </div>
      <BookingInquirySection />
      <Footer />
    </div>;
}